import CobranzaListCustom from './CobranzaListCustom'
export {CobranzaListCustom}
export default CobranzaListCustom
